function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagemPorque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.6,103.84s-29.06-58.17-93.22-66.79S246.42,70.44,199.21,92c-24.73,11.28-53,6.9-79.22,12.36C36.06,121.81,4.44,231.2,39.4,293.42c30.27,53.86,83.54,81.86,164.65,88.33s138,14,210.65-38.78S482.49,180.31,448.6,103.84Z",
    style: {
      fill: "#EE0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.6,103.84s-29.06-58.17-93.22-66.79S246.42,70.44,199.21,92c-24.73,11.28-53,6.9-79.22,12.36C36.06,121.81,4.44,231.2,39.4,293.42c30.27,53.86,83.54,81.86,164.65,88.33s138,14,210.65-38.78S482.49,180.31,448.6,103.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-152"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.18,
    cy: 439.34,
    rx: 201.92,
    ry: 11.03,
    style: {
      fill: "#EE0000"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.18,
    cy: 439.34,
    rx: 201.92,
    ry: 11.03,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Products--inject-152"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "439.15 160.51 83.11 160.51 83.11 180.51 459 180.51",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "439.15 221.51 83.11 221.51 83.11 241.51 459 241.51",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "439.15 282.51 83.11 282.51 83.11 302.51 459 302.51",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "439.15 343.51 83.11 343.51 83.11 363.51 459 363.51",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "439.15 405.01 83.11 405.01 83.11 425.01 459 425.01",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.65,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.31,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.98,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.67,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.33,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.31,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.98,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.67,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.65,
    y: 130.78,
    width: 41.55,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.33,
    y: 130.78,
    width: 16.86,
    height: 29.77,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.33,
    y: 197.84,
    width: 13.67,
    height: 24,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.33,
    y: 190.84,
    width: 13.67,
    height: 7,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H87.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,94,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H87.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,94,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H127.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,134,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H167.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,174,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H207.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,214,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H247.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,254,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,323.84h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H287.33a0,0,0,0,1,0,0V330.51A6.67,6.67,0,0,1,294,323.84Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 316.18,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H119.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,126,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H151.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,158,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H183.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,190,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H215.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,222,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H247.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,254,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H279.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,286,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,262.18h15.33a6.67,6.67,0,0,1,6.67,6.67v13.33a0,0,0,0,1,0,0H311.33a0,0,0,0,1,0,0V268.84A6.67,6.67,0,0,1,318,262.18Z",
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 254.51,
    width: 16,
    height: 7.67,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.13,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.15,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.17,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.22,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.24,
    y: 385.37,
    width: 49.17,
    height: 19.48,
    style: {
      fill: "none",
      stroke: "#92989b",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.22,421.49l.53-4.78-18.51-1.13,6.84,8.8a8.49,8.49,0,1,0,11.14-2.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.53,421.49l.53-4.78-18.51-1.13,6.85,8.8a8.49,8.49,0,1,0,11.13-2.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,421.49l.53-4.78-18.51-1.13,6.85,8.8a8.49,8.49,0,1,0,11.13-2.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.87,197H278a15.19,15.19,0,0,1,15.19,15.19V378a0,0,0,0,1,0,0H218.68a0,0,0,0,1,0,0V212.17A15.19,15.19,0,0,1,233.87,197Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.68,
    y1: 234.25,
    x2: 293.21,
    y2: 234.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.38,
    y1: 234.56,
    x2: 254.38,
    y2: 377.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.51,
    y: 330.09,
    width: 83.45,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.67,
    y: 330.09,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.86,
    y: 336.61,
    width: 22.82,
    height: 10.43,
    rx: 5.22,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.19,
    y: 330.09,
    width: 83.45,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.34,
    y: 330.09,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.53,
    y: 336.61,
    width: 22.82,
    height: 10.43,
    rx: 5.22,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.67,
    y: 264.04,
    width: 83.45,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.82,
    y: 264.04,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.61,281H291.22a5.21,5.21,0,0,1-5.21-5.21h0a5.22,5.22,0,0,1,5.21-5.22h12.39a5.22,5.22,0,0,1,5.22,5.22h0A5.22,5.22,0,0,1,303.61,281Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.11,
    y: 197.29,
    width: 83.45,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.26,
    y: 197.29,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,214.24H320.67a5.21,5.21,0,0,1-5.22-5.21h0a5.22,5.22,0,0,1,5.22-5.22h12.38a5.22,5.22,0,0,1,5.22,5.22h0A5.22,5.22,0,0,1,333.05,214.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.97,
    y: 264.04,
    width: 83.44,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.12,
    y: 264.04,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,281H349.52a5.21,5.21,0,0,1-5.21-5.21h0a5.22,5.22,0,0,1,5.21-5.22h12.39a5.22,5.22,0,0,1,5.22,5.22h0A5.22,5.22,0,0,1,361.91,281Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.55,
    y: 330.09,
    width: 83.45,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.71,
    y: 330.09,
    width: 31.29,
    height: 66.5,
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 336.61,
    width: 22.82,
    height: 10.43,
    rx: 5.22,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.93,197h44.15a15.19,15.19,0,0,1,15.19,15.19V378a0,0,0,0,1,0,0H383.74a0,0,0,0,1,0,0V212.17A15.19,15.19,0,0,1,398.93,197Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.74,
    y1: 234.25,
    x2: 458.27,
    y2: 234.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.44,
    y1: 234.56,
    x2: 419.44,
    y2: 377.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.82,
    cy: 428.99,
    r: 8.5,
    transform: "translate(-236.85 552.58) rotate(-75.59)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.84,415.58l11.49,14.77a3.19,3.19,0,0,0,4.16.77h0a3.19,3.19,0,0,0,1.53-2.38l1.33-12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.35,
    cy: 428.99,
    r: 8.5,
    transform: "translate(-162.48 652.48) rotate(-76.67)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,415.58l11.48,14.77a3.19,3.19,0,0,0,4.16.77h0a3.19,3.19,0,0,0,1.53-2.38l1.34-12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.97,
    cy: 428.99,
    r: 8.5,
    transform: "translate(-107.37 722.18) rotate(-76.67)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,415.58l11.49,14.77a3.19,3.19,0,0,0,4.16.77h0a3.19,3.19,0,0,0,1.53-2.38l1.33-12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.05,
    y: 378.2,
    width: 240.17,
    height: 38.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.62,
    y: 378.2,
    width: 74.6,
    height: 38.16,
    style: {
      fill: "#c4c4c4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.11,222.36a27.49,27.49,0,0,0-6.08,6.43c-2,3.38-19.95,27.72-19.95,27.72l6.43,9.46,19.6-9.46a190.62,190.62,0,0,1,1.69-20.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.34,269.5s5.41-1.69,7.1-6.76-.34-9.13-6.09-12.85-10.14-1.69-13.18,1.36-3,9.8-.34,13.52S230.29,269.16,233.34,269.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,276.94s6.42-11.83,6.42-16.9-8.45-8.46-13.52-6.77-3.72,10.15-3,13.53,1.69,9.46,1.35,13.18-2,5.07.67,6.09S229.62,281.67,231.31,276.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.31,431s-12.17,6.76-15.21,9.13-4.4,4.05-1,5.07,8.11,1.69,12.17.34,6.08-2.71,8.45-3.72,5.07-.68,5.07-5.41v-4.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.62,438.05c-1.1.27-2.45.62-3.9,1-3.72,1-6.42,4.74-11.83,5.07-3.75.24-8.62-1-11.27-1.76-.92,1.2-.7,2.13,1.47,2.78,3.38,1,8.11,1.69,12.17.34s6.08-2.71,8.45-3.72C267.74,440.89,270,441,270.62,438.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.16,433.32s-9.81,9.46-14.2,11.83,11.16,3,15.89,2.7,5.75-2.7,8.11-4.39a7.19,7.19,0,0,0,3.05-6.09,3.9,3.9,0,0,0-1.36-3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,447.85c4.73-.34,5.75-2.7,8.11-4.39a7.19,7.19,0,0,0,3.05-6.09h0c-2.26,2.86-6.67,7.54-11.83,8.12-6.08.67-15.21-.34-15.21-.34C255.57,447.51,271.12,448.19,275.85,447.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,288.62s-4.73,42.6-3,64.57S261.31,431,261.31,431l9.47.68s.67-33.47,1-52.4,3.38-84.18,3.38-84.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.09,295.72a27.75,27.75,0,0,1,4.4,16.23c-.34,9.8-3.72,23-3.72,29.41s-2,22.31-2,27.72-2,18.6-2,31.11-4.06,34.14-4.06,34.14l-11.49-1s-4.06-34.15-5.41-46.66-2.37-33.13-2.37-34.82.68-57.47.68-57.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,181.37s-6.7.89-8-8,11.16-17,22.32-19.64S294.2,151,300,164.41s-2.68,29-2.68,29,9.82,16.07,10.72,27.68-4.47,17.4-4.47,17.4l-11.16-4.91s7.15-24.1.9-38.83c0,0-11.16,1.34-12.95-2.68s-7.59-16.07-8.93-16.51S260.28,181.37,260.28,181.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,167.1s6.1-9.15,13.62-10.57",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,168.53a147.33,147.33,0,0,0,12.81,12.61l6.1,5.08",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,163.24s12.81,5.49,15.05,17.9",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.59,164.66s-23,5.7-22.37,9.76",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,171.37s13.42-16.06,30.3-13.62",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.75,213.91s-21.64,6.42-21.64,8.45,0,65.93.68,67.95,31.78,7.44,35.5,7.1,7.77-.67,9.8-1.69,12.85-59.83,14.54-63.55-.34-8.12-3.38-10.15-27.39-7.43-27.39-7.43A34.52,34.52,0,0,0,268.75,213.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,218s-7.78,39.89-9.47,56.45-6.08,79.11-6.08,79.11,9.12,5.41,23.32,5.41h25.36v-76.4l7.44-.34.67-3-8.79-3.72s1-30.43,1.69-42.26,1-14.87,1-14.87l-3.38-1L283,252.11,256.58,246,261,216.62Z",
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.78,209.18s-5.75,1-8.12,4.73-8.11,18.93-3.71,19.61,9.8-6.76,12.5-6.76,5.08,11.15,11.5,10.48,7.1-14.54,5.75-22S273.14,207.83,270.78,209.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.72,200.05s1.35,15.21,1.35,21.64-1.35,9.12,2.71,9.12,13.52-12.5,13.52-18.25v-14.2S272.13,200.73,266.72,200.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.56,221s6.76,2.7,8.79,6.09,14.08,46.31,14.08,46.31l-16.9,9.8-10.71-31.77a110.72,110.72,0,0,1-.33-13.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,277.13s-.56-7.44,1.41-10.82,13.82-9.13,18.61-8.11,5.08,11.83,2.26,14.87S306.55,281.86,303.45,277.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.95 289.43 277.66 302.12 265.84 320.69 206.87 300.41 229.95 289.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.21 289.43 229.95 276.98 229.95 289.43 206.21 302.46 206.21 289.43",
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.95 289.43 281.48 303.62 282.63 290.88 229.95 276.98 229.95 289.43",
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,288.66a6.63,6.63,0,1,1-6.63-6.63A6.63,6.63,0,0,1,238.4,288.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.73,
    cy: 293.45,
    r: 6.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.25,
    cy: 294.75,
    r: 6.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.99,
    cy: 298.88,
    r: 6.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,303a6.63,6.63,0,1,1-6.63-6.63A6.63,6.63,0,0,1,264.27,303Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,294.1a6.63,6.63,0,1,1-6.63-6.63A6.63,6.63,0,0,1,228,294.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.42,
    cy: 298.23,
    r: 6.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,301.27a6.63,6.63,0,1,1-6.63-6.63A6.63,6.63,0,0,1,251,301.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.63 290.88 265.84 305.93 265.84 320.69 281.48 303.62 282.63 290.88",
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.84 305.93 206.21 289.43 206.21 302.46 265.84 320.69 265.84 305.93",
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.82,270.49l-12.74,11s-6.73-1.22-8.87.31a61.88,61.88,0,0,0-8.87,9.17,1.43,1.43,0,0,0,2.14,1.84c1.22-.92,6.42-4,6.42-4s-.91,10.09-1.83,11.93S276,307,277.51,307s6-1,7.23-2,2.44-3.67,2.44-3.67,5.81-2.75,5.81-3.67,2.14-4.89,2.14-4.89l2.76-4.89s15.8-3.67,20.08-6.73,11.92-8.26,9.48-14.37S319.19,258.86,304.82,270.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,277a2.89,2.89,0,0,0-2.76-3.39,4,4,0,0,0-3.44,1.1c-1.69,2-5.07,9.46-3.38,11.49s5.07-6.76,5.07-6.76S229.28,279.67,229.87,277Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.11,168.87l-15.62,8.93s-1.34,12.5,0,21.42,8.93,12.5,16.07,12.5,12.94-6.25,13.39-8.48.89-4.46.89-4.46,6.7-.9,7.14-7.6-3.57-7.58-4.91-6.24l-2.67,2.68S278.58,180.48,274.11,168.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.93,187c0,1.27-.59,2.3-1.31,2.3s-1.31-1-1.31-2.3.58-2.29,1.31-2.29S266.93,185.75,266.93,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.32,188.41c0,1.26-.59,2.29-1.31,2.29s-1.31-1-1.31-2.29.58-2.3,1.31-2.3S277.32,187.14,277.32,188.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,187.43s-1,3.75-1.5,5.5,0,4,3,3.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.88,200.25s3.86,1,7.53-3.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.23,182.18a3.72,3.72,0,0,1,5-.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,182.68s4.75-2,6.75,1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.53,436.47s4.32,8.65,11.53,13,15.14,3.24,15.14-2.17-5.4-9.73-9.73-12.61S152.69,429.62,150.53,436.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,446.7c-2.27,1.41-6,3.2-10.06,2.75s-10.45-5.74-14.5-9.52a32.09,32.09,0,0,0,9.45,9.52c7.21,4.32,15.14,3.24,15.14-2.17C177.2,447.09,177.18,446.89,177.17,446.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58,433.59s-4.32,8.65-11.53,13-15.14,3.25-15.14-2.16,5.4-9.73,9.73-12.62S131.42,426.74,133.58,433.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94,443.82c2.27,1.41,6,3.19,10.06,2.74s10.45-5.73,14.5-9.51a32,32,0,0,1-9.45,9.51c-7.21,4.33-15.14,3.25-15.14-2.16C106.91,444.2,106.93,444,106.94,443.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,296.24s-2.52,15.86.72,27.4,4.33,18.38,4.33,29.2,3.6,50.46,5,57S115.2,435,115.2,435s9,3.6,13,2.16a8.34,8.34,0,0,0,5-4.33l5.41-87.23L139.71,329h2.16s3.61,71.38,5,82.2,1.8,24.87,1.8,24.87,4.33,2.16,6.85,2.16,11.54-1.44,11.9-3.6a24.06,24.06,0,0,0,0-7.21c-.36-1.44-1.08-6.13-1.08-6.13s6.13-63.09,6.13-69.22-.72-53.71-.72-53.71l-1.45-2.16s-10.45,4-29.2,4-32.44-5.4-34.6-6.85S101.14,294.08,101.5,296.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,198.19s-18.74,6.84-21.62,12.25-5,83.28-4.33,85.8S123.85,306,140.79,306s32.09-6.13,32.81-9.37-.72-79-4.33-85.8S157.74,198.19,147.64,196,127.45,198.19,127.45,198.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.87,205.4s6.85,27.39,8.29,34.6.72,40,.72,40l-19.46-1.45.36,4,19.1,4-5,67.77s17.66,6.49,33.88,5.77a57.65,57.65,0,0,0,27.4-8.3s-2.88-45.42-2.88-74.26-1.44-52.63-1.44-57-2.67-12-7-15.61c0,0,1.58,7.68,2.3,15.25a96.72,96.72,0,0,1-.36,16.94l-41.46-.36-9-34.61Z",
    style: {
      fill: "#EE0000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,209s-9,5.77-12.62,10.09-10.81,49.39-10.81,53,5,5,7.93,5,10.45-2.88,11.89-7.93,10.1-30.28,10.1-30.28.36-6.85.36-9.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,243.46c-4-1.31-7.67-1-8.23.68l-12,36.47,14.44,4.75,12-36.46C187.88,247.21,185.1,244.77,181.11,243.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.31,285.36c-.55,1.69-4.24,2-8.22.68s-6.77-3.74-6.22-5.43,4.24-2,8.23-.69S175.87,283.67,175.31,285.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,243.46c-4-1.31-7.67-1-8.23.68l-2.33,7.1c2.71-.38,7.87-.08,14.27,5.24l2.5-7.58C187.88,247.21,185.1,244.77,181.11,243.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.69,268.9a29.76,29.76,0,0,0-3.47,1.43c-1.63.81-1,1.42-.2,1.42s3.67.21,5.1-.81S182.73,268.69,180.69,268.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,265.55s1,1.8-.26,2.83-7.22,1.29-8.25.52,1.81-2.07,3.61-2.32S185,265.55,185,265.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,263.18s1,1.8-.26,2.84-7.22,1.28-8.25.51,1.81-2.06,3.61-2.32S185.6,263.18,185.6,263.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.79,260.6a39.38,39.38,0,0,0-4.38,1.81c-2.06,1-1.29,1.8-.25,1.8s4.63.26,6.44-1S186.37,260.35,183.79,260.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.12 282.95 116.46 285.14 112.9 312.52 92.37 307.59 88.53 303.48 96.75 290.89 98.12 282.95",
    style: {
      fill: "#828282",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.53 303.48 110.44 308.14 116.46 285.14 112.9 312.52 92.37 307.59 88.53 303.48",
    style: {
      fill: "#828282",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.44 308.14 112.9 312.52 91.27 307.87 88.53 303.48 110.44 308.14",
    style: {
      fill: "#5c5c5c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.23 304.67 98.12 297.73 105.78 299.38 103.05 306.5 95.23 304.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58,192.06s-12.25,5.4-11.89,9,6.85,24.15,10.81,25.23,11.9-9.37,11.9-9.37,6.49,8.29,10.45,7.57,2.53-4.69,1.44-16.58-5-11.54-10.81-14.42A19.46,19.46,0,0,0,133.58,192.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,162.14s5.77-1.81,7.21-7.21-6.13-18-17.3-22-24.52-2.53-31,7.21-6.49,18.74-4.32,25.23,5.77,11.18,7.21,11.9,2.52-4.69,9.37-6.49A43.56,43.56,0,0,0,148,161.42a14.82,14.82,0,0,0,3.61-5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06,189.89s-1.08,8.3,1.8,14.42,7.21,14.06,10.46,14.06,7.57-8.29,9-13.34,1.8-13.33,1.8-13.33S141.87,196,131.06,189.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.73,167.54l10.1-9.37.72,4s9-4.33,11.53-7.93,2.53-5.05,2.53-5.05l9,10.45s1.44,19.47-.36,25.6-2.16,12.25-11.18,13.7-18.38-4.69-21.26-10.1a62.09,62.09,0,0,1-4-8.65s-6.85-5-6.49-11.17S123.13,163.22,126.73,167.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.08,169.32c0,1.27.59,2.29,1.31,2.29s1.31-1,1.31-2.29-.58-2.3-1.31-2.3S154.08,168.05,154.08,169.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,170.71c0,1.27.59,2.29,1.32,2.29s1.31-1,1.31-2.29-.59-2.3-1.31-2.3S141.06,169.44,141.06,170.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.67,169.73s1.31,5.25,2,7.7,0,5.6-3.94,4.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.78,164.48a3.72,3.72,0,0,0-5-.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,165s-4.75-2-6.75,1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,187.25s-4.54,1.61-11.21-2.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,171.51s1.07-5.34,3.47-2.67a16.63,16.63,0,0,1,2.94,4s-4.27-.53-2.67,2.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,279.81s-1.33,4.88-.59,5.18,5.62,1.18,6.8.59,0-2.22,0-2.22l5.77-23.2-10.34-.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.72,266.26s8.19-5.7,16.73-5.34,9.61,5.69,9.61,9.25-17.8,12.45-21.71,12.45S77.38,275.51,82.72,266.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,268.48s-15.86-3.24-22-4-16.94,2.88-19.1,9,4.68,9.73,10.09,11.17S126,281.1,126,281.1s12.26.72,14.42-2.89S144,267,144,267s5.77-2.16,4.32-5.05-17.3-3.24-19.46-2.52S125.29,268.48,125.29,268.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,253.8h-8.58a3.09,3.09,0,0,0-.25,6.18l0,0h19.8L159,253.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,260h-8.58a3.1,3.1,0,0,1-3.1-3.11h0a3.1,3.1,0,0,1,3.1-3.1H158a3.1,3.1,0,0,1,3.1,3.1h0A3.1,3.1,0,0,1,158,260Z",
    style: {
      fill: "#5c5c5c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagemPorque);
export default __webpack_public_path__ + "static/media/imagem-porque.66f5a6dc14209e6369833b41efe5337b.svg";
export { ForwardRef as ReactComponent };